import { useMemo } from 'react';

import type { RolodexRecordStatus } from '../../../../../../../../graphql';
import { AddInvestorFirmSalesCoverage } from '../../AddInvestorFirmSalesCoverage/AddInvestorFirmSalesCoverage';
import { AddInvestorContact } from '../../FirmsInvestorContactsGrid/components/AddInvestorContact/AddInvestorContact';
import type { firmDetailGridsRoutes } from '../FirmDetailGridsNav.model';

export function useFirmDetailGridsNavActions(
  firmStatus: RolodexRecordStatus,
  matchedRouteName?: keyof typeof firmDetailGridsRoutes
) {
  return useMemo(() => {
    switch (matchedRouteName) {
      case 'customerCrmInvestorFirmInvestorContactsGrid':
      case 'sysAdminCrmInvestorFirmInvestorContactsGrid':
        return [<AddInvestorContact key="add-investor-contact-button" />];
      case 'customerCrmInvestorFirmSalesCoverageGrid':
      case 'sysAdminCrmInvestorFirmSalesCoverageGrid':
        return [
          <AddInvestorFirmSalesCoverage
            key="add-investor-firm-sales-coverage-button"
            firmStatus={firmStatus}
          />,
        ];
      default:
        return [];
    }
  }, [matchedRouteName, firmStatus]);
}
